import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const PlusIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M16 28V4.43M27.785 16.215H4.215" />
  </IconV2>
);

export default PlusIcon;
